import {FormControl, FormField, GroupedOption, Option} from 'platform/components';
import {Box, Integer} from 'platform/foundation';

import {FieldPathByValue, useWatch} from 'react-hook-form';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

interface PageItemChoiceInputProps {
  index: number;
  isCollapsed: boolean;
  isConfirmed: boolean;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  name: FieldPathByValue<DeliveryNoteDocumentPreviewFormDefinition, string | Nullish>;
  width: Integer;
  options: Option[] | GroupedOption[];
  isLoadingOptions?: boolean;
  onChange?: (fieldName: string, value: string | number) => void;
}

export function PageItemChoiceInput(props: PageItemChoiceInputProps) {
  const [value, isActive] = useWatch({
    control: props.control,
    name: [props.name, `listOfItems.${props.index}.isActive`],
  });

  const handleChange = (value: string | number | null) => {
    if (isNil(value)) {
      return;
    }
    props.onChange?.(props.name, value);
  };

  return (
    <Box paddingHorizontal={2} width={props.isCollapsed ? '100%' : props.width}>
      <FormField
        isNotClearable
        isDisabled={!props.isConfirmed || !isActive}
        isInvalid={props.isConfirmed && isActive && !value}
        isLoading={props.isLoadingOptions}
        control={props.control}
        type="choice"
        options={props.options}
        name={props.name}
        onChange={handleChange}
        menuInPortal
      />
    </Box>
  );
}
